var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.92 19.7988H27.7201C24.075 19.7988 21.1201 22.7537 21.1201 26.3988V105.599C21.1201 109.244 24.075 112.199 27.7201 112.199H106.92C110.565 112.199 113.52 109.244 113.52 105.599V26.3988C113.52 22.7537 110.565 19.7988 106.92 19.7988Z",
    fill: "#F2F5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_370_34913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6403 55.4395H124.74C125.616 55.4395 126.455 55.7871 127.074 56.406C127.693 57.0249 128.04 57.8642 128.04 58.7395V75.2395C128.04 76.1147 127.693 76.954 127.074 77.5729C126.455 78.1918 125.616 78.5395 124.74 78.5395H35.6403C34.7651 78.5395 33.9257 78.1918 33.3069 77.5729C32.688 76.954 32.3403 76.1147 32.3403 75.2395V58.7395C32.3403 57.8642 32.688 57.0249 33.3069 56.406C33.9257 55.7871 34.7651 55.4395 35.6403 55.4395V55.4395Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.4803 60.7188H67.3203C66.2268 60.7188 65.3403 61.6052 65.3403 62.6988C65.3403 63.7923 66.2268 64.6788 67.3203 64.6788H84.4803C85.5739 64.6788 86.4603 63.7923 86.4603 62.6988C86.4603 61.6052 85.5739 60.7188 84.4803 60.7188Z",
    fill: "#CACFD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.3603 69.2988H67.3203C66.2268 69.2988 65.3403 70.1853 65.3403 71.2788C65.3403 72.3724 66.2268 73.2588 67.3203 73.2588H96.3603C97.4539 73.2588 98.3403 72.3724 98.3403 71.2788C98.3403 70.1853 97.4539 69.2988 96.3603 69.2988Z",
    fill: "#CACFD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4702 73.2568C55.933 73.2568 58.7402 70.4496 58.7402 66.9868C58.7402 63.524 55.933 60.7168 52.4702 60.7168C49.0074 60.7168 46.2002 63.524 46.2002 66.9868C46.2002 70.4496 49.0074 73.2568 52.4702 73.2568Z",
    fill: "#CACFD8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_370_34913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25996 83.8184H96.36C97.2352 83.8184 98.0745 84.166 98.6934 84.7849C99.3123 85.4038 99.66 86.2431 99.66 87.1184V103.618C99.66 104.494 99.3123 105.333 98.6934 105.952C98.0745 106.571 97.2352 106.918 96.36 106.918H7.25996C6.38475 106.918 5.54538 106.571 4.92651 105.952C4.30764 105.333 3.95996 104.494 3.95996 103.618V87.1184C3.95996 86.2431 4.30764 85.4038 4.92651 84.7849C5.54538 84.166 6.38475 83.8184 7.25996 83.8184V83.8184Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.1 89.0996H38.94C37.8464 89.0996 36.96 89.9861 36.96 91.0796C36.96 92.1731 37.8464 93.0596 38.94 93.0596H56.1C57.1935 93.0596 58.08 92.1731 58.08 91.0796C58.08 89.9861 57.1935 89.0996 56.1 89.0996Z",
    fill: "#CACFD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.98 97.6797H38.94C37.8464 97.6797 36.96 98.5662 36.96 99.6597C36.96 100.753 37.8464 101.64 38.94 101.64H67.98C69.0735 101.64 69.96 100.753 69.96 99.6597C69.96 98.5662 69.0735 97.6797 67.98 97.6797Z",
    fill: "#CACFD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5093 101.64C18.9721 101.64 21.7793 98.8324 21.7793 95.3696C21.7793 91.9068 18.9721 89.0996 15.5093 89.0996C12.0464 89.0996 9.23926 91.9068 9.23926 95.3696C9.23926 98.8324 12.0464 101.64 15.5093 101.64Z",
    fill: "#CACFD8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_370_34913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.36 27.0586H7.25996C5.43742 27.0586 3.95996 28.5361 3.95996 30.3586V46.8586C3.95996 48.6811 5.43742 50.1586 7.25996 50.1586H96.36C98.1825 50.1586 99.66 48.6811 99.66 46.8586V30.3586C99.66 28.5361 98.1825 27.0586 96.36 27.0586Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.7801 32.3398H37.6201C36.5266 32.3398 35.6401 33.2263 35.6401 34.3198C35.6401 35.4134 36.5266 36.2998 37.6201 36.2998H54.7801C55.8737 36.2998 56.7601 35.4134 56.7601 34.3198C56.7601 33.2263 55.8737 32.3398 54.7801 32.3398Z",
    fill: "#CACFD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.6601 40.9199H37.6201C36.5266 40.9199 35.6401 41.8064 35.6401 42.8999C35.6401 43.9934 36.5266 44.8799 37.6201 44.8799H66.6601C67.7537 44.8799 68.6401 43.9934 68.6401 42.8999C68.6401 41.8064 67.7537 40.9199 66.6601 40.9199Z",
    fill: "#CACFD8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0893 44.8798C27.5522 44.8798 30.3593 42.0727 30.3593 38.6098C30.3593 35.147 27.5522 32.3398 24.0893 32.3398C20.6265 32.3398 17.8193 35.147 17.8193 38.6098C17.8193 42.0727 20.6265 44.8798 24.0893 44.8798Z",
    fill: "#CACFD8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_370_34913",
    x: 28.3803,
    y: 53.4595,
    width: 103.62,
    height: 31.0196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.98
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_370_34913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_370_34913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_370_34913",
    x: -0.0000391006,
    y: 81.8384,
    width: 103.62,
    height: 31.0196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.98
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_370_34913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_370_34913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_370_34913",
    x: -0.0000391006,
    y: 25.0786,
    width: 103.62,
    height: 31.0196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.98
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_370_34913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_370_34913",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversations);
export default __webpack_public_path__ + "static/media/conversations.4c0507a4435596ce892867e33f4830e5.svg";
export { ForwardRef as ReactComponent };